module.exports = __webpack_public_path__ + "img/kpi_diagram_blank_top.430b3aac.png";